import { storage } from '@/utils/storage';
import { getShopId } from '@/utils/vuex';

export default {
  setAuth(store, token) {
    const shopId = getShopId(token);
    storage.setItem('OPW_TOKEN', token);
    store.commit('setAuth', { shopId, token });
  },
  removeAuth({ commit }) {
    storage.removeItem('OPW_TOKEN');
    commit('removeAuth');
  },
};
